package com.macrofocus.eflux.ui.perspective

import com.macrofocus.colormapping.implementation.SimpleColorMapping
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.toRawString
import com.macrofocus.high_d.ParallelCoordinates
import com.macrofocus.high_d.parallelcoordinates.DefaultParallelCoordinatesModel
import com.macrofocus.high_d.parallelcoordinates.ParallelCoordinatesModel
import com.macrofocus.visual.SimpleVisual
import com.macrofocus.visual.SimpleVisualObjects
import js.objects.unsafeJso
import kotlinx.browser.window
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import org.mkui.colormap.ColorMapFactory
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import org.molap.dataframe.DataFrame
import org.molap.json.readJson
import org.molap.subset.SubsetDataFrame
import react.FC
import react.Props
import react.useEffect
import react.useState
import web.cssom.Position
import web.cssom.px

class ParallelCoordinatesPerspective(private val dataLoader: DataLoader) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        val theme = useTheme<Theme>()

        val (parallelCoordinatesModel, setParallelCoordinatesModel) = useState<ParallelCoordinatesModel<Int, String>?>(null)

        val (getShiftedDateTime, _) = useProperty(dataLoader.masterDateTime)
        val shiftedDateTime = getShiftedDateTime.toRawString()

        useEffect(shiftedDateTime) {
            window.fetch("data/lines-eflux.json?datetime=$shiftedDateTime").then {
                it.text().then {
                    val dataFrame = DataFrame.readJson(it)
                    val subsetDataFrame = SubsetDataFrame(dataFrame)

                    val colorMapFactory = ColorMapFactory.instance
                    val visual = SimpleVisual(
                        SimpleVisualObjects<Int>(dataFrame), SimpleColorMapping<Int, String>(
                            colorMapFactory, dataFrame
                        )
                    )

                    val model = DefaultParallelCoordinatesModel<Int, String>(dataFrame, visual)
                    model.setHidden(model.getAxisHierarchy().getAxisModel("p")!!, false)
                    model.setHidden(model.getAxisHierarchy().getAxisModel("q")!!, false)
                    model.setHidden(model.getAxisHierarchy().getAxisModel("pratea")!!, false)
                    model.setHidden(model.getAxisHierarchy().getAxisModel("o1")!!, true)
                    model.setHidden(model.getAxisHierarchy().getAxisModel("met")!!, true)
                    model.setHidden(model.getAxisHierarchy().getAxisModel("t_70m_max")!!, false)
                    model.setHidden(model.getAxisHierarchy().getAxisModel("wind_speed_70m_max")!!, false)
                    model.setHidden(model.getAxisHierarchy().getAxisModel("wind_gusts_70m_1h_max")!!, false)
                    model.setHidden(model.getAxisHierarchy().getAxisModel("weather_code_1h_min")!!, false)
                    setParallelCoordinatesModel(model)
                }
            }
        }

        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx = unsafeJso {
                position = Position.absolute
                top = 0.px
                bottom = 0.px
                left = 0.px
                right = 0.px

                customBackground(this)
            }

            ParallelCoordinates {
                this.model = parallelCoordinatesModel
            }
        }
    }

}